require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-salisbury-city-of-stories.json") })
        }
      }, "path---authors-salisbury-city-of-stories");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-salisbury-city-of-stories!./.cache/json/authors-salisbury-city-of-stories.json
// module id = 1332
// module chunks = 231608221292675